import BannerCardDetailsImpl from './banner-card-details';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';
import BannerCardTypes from 'modules/event-cards/banner/types.js';

const { BANNER_CARD_MODES } = BannerCardTypes;
const { UIView } = MojitoCore.Presentation;

/**
 * Banner card details component.
 *
 * @function BannerCardDetails
 * @name BannerCardDetails
 *
 * @memberof Mojito.Modules.EventCards.Banner
 */

/**
 * Banner card details prop types.
 *
 * @property {Function} onClick - Callback function to be triggered when the primary or secondary button is clicked. The button's url is passed as a parameter.
 * @property {object} cardBannerDetails - Banner card details.
 *
 * @memberof Mojito.Modules.EventCards.Banner
 */

const propTypes = {
    onClick: PropTypes.func,
    cardBannerDetails: PropTypes.shape({
        headlineText: PropTypes.string,
        primaryText: PropTypes.string,
        secondaryText: PropTypes.string,
        primaryButton: PropTypes.shape({
            text: PropTypes.string,
            link: PropTypes.string,
        }),
        secondaryButton: PropTypes.shape({
            text: PropTypes.string,
            link: PropTypes.string,
        }),
        colorMode: PropTypes.oneOf(Object.keys(BANNER_CARD_MODES)),
    }).isRequired,
};

const defaultProps = {
    onClick: noop,
};

export default UIView('BannerCardDetails', BannerCardDetailsImpl, propTypes, defaultProps);
